import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row, Label, Button } from 'reactstrap';
import { update_bot_details } from '../../slices/thunks';
import Loader from '../../Components/Common/Loader';
import { Editor } from '@tinymce/tinymce-react';
import config from '../../config';

const Bot_Description = () => {
  const { Bot_Details: botDetails, loading } = useSelector((state) => state.BotDetails);
  const dispatch = useDispatch();

  const {
    Bot_ID,
    User_Role,
    Bot_Description: botDescriptionFromStore = '', // rename to avoid clash
  } = botDetails || {};

  const [description, setDescription] = useState('');

  useEffect(() => {
    setDescription(botDescriptionFromStore || '');
  }, [botDescriptionFromStore]);

  const editorRef = useRef(null);

  const onClickSave_BotConfig = () => {
    dispatch(
      update_bot_details({
        Bot_ID,
        description, // send the edited HTML back
      })
    );
  };

  const handleEditorChange = (content /*, editor */) => {
    const plain = editorRef.current?.getContent({ format: 'text' }) || ''
    console.log(plain)
    setDescription(content);
  };

  const readEditorContent = () => {
    if (editorRef.current) {
      console.log(editorRef.current.getContent());
    }
  };

  const isReadOnly = User_Role === 'BotUser' || User_Role === 'Viewer';

  return (
    <>
      <div className="mt-5">
        <div className="ws-fb" style={{ textAlign: 'right' }}>
          <Button onClick={onClickSave_BotConfig} disabled={loading}>
            {loading ? 'Saving…' : 'Save'}
          </Button>
        </div>

        <div className="bot_description_wrap border-padding">
          <Row>
            {/* If you still want the simple textarea, keep it commented as reference */}
            {/* <Col xxl={12} md={12}>
              <div className="mt-4 calc-height">
                <Label htmlFor="type" className="form-label">Bot description</Label>
                {loading ? (
                  <Loader />
                ) : (
                  <textarea
                    disabled={isReadOnly}
                    onChange={(e) => setDescription(e.target.value)}
                    value={description}
                    className="form-control"
                    id="botdescription"
                    rows="10"
                    placeholder="Enter your message"
                  />
                )}
              </div>
            </Col> */}
            <Col xxl={12} md={12}>
              <div className="mt-3 calc-height">
                <Label htmlFor="botinstruction" className="form-label">
                                Bot description
                              </Label>
                {loading ? (
                  <Loader />
                ) : (
                  <Editor
                    apiKey={config.api.tiny_mce_api_key}
                    onInit={(_evt, editor) => (editorRef.current = editor)}
                    value={description}                     // controlled
                    onEditorChange={handleEditorChange}     // TinyMCE callback
                    disabled={isReadOnly}
                  
                    init={{
                      branding:false,
                      height: "95%",
                      menubar: false,
                      resize: false,
                      plugins: [
                        'advlist',
                        'autolink',
                        'lists',
                        'link',
                        'image',
                        'charmap',
                        'anchor',
                        'searchreplace',
                        'visualblocks',
                        'code',
                        'fullscreen',
                        'insertdatetime',
                        'media',
                        'table',
                        'preview',
                        'help',
                        'wordcount',
                      ],
                      toolbar:
                        'undo redo | blocks | ' +
                        'bold italic forecolor | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'removeformat | help',
                      content_style:
                        'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                    }}
                  />
                )}
                </div>
            </Col>
            
          </Row>
        </div>
      </div>
    </>
  );
};

export default Bot_Description;
